<template>
  <transition name="fade">
    <div
      v-show="visible"
      tabindex="-1"
      class="h-modal"
      @keyup.esc="onEscapePressed"
    >
      <div
        v-if="mask"
        class="mask"
        @click="onMaskClicked"
      />
      <transition
        :name="transitionName"
        @after-enter="afterEnter"
        @after-leave="afterLeave"
      >
        <div
          v-if="visible"
          class="h-modal__content"
          :style="modalStyle"
        >
          <div
            v-if="showClose"
            type="close"
            class="close"
            @click="close"
          />
          <slot />
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'HModal',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    transitionName: {
      type: String,
      default: 'h-modal'
    },
    showClose: {
      type: Boolean,
      default: true
    },
    mask: {
      type: Boolean,
      default: true
    },
    closeOnClickMask: {
      type: Boolean,
      default: true
    },
    closeOnPressEscape: {
      type: Boolean,
      default: false
    },
    modalStyle: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    visible (isShow) {
      isShow &&
        this.$nextTick(() => {
          this.$el.focus()
          this.$emit('show')
        })
    }
  },
  methods: {
    close () {
      this.$emit('hide')
      this.$emit('update:visible', false)
    },
    onMaskClicked () {
      if (this.closeOnClickMask) {
        this.close()
      }
    },
    onEscapePressed () {
      if (this.closeOnPressEscape) {
        this.close()
      }
    },
    afterEnter () {
      this.$emit('after-enter')
    },
    afterLeave () {
      this.$emit('after-leave')
    }
  }
}
</script>

<style lang="scss">
.h-modal,
.h-modal .mask {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  * {
    -webkit-app-region: no-drag;
  }
}
.h-modal {
  position: fixed;
  text-align: center;
  .mask {
    position: absolute;
    background: rgba(0, 0, 0, 0.5);
  }
  &:after {
    content: '';
    display: inline-block;
    height: 100%;
    vertical-align: middle;
  }

  .h-modal__content {
    position: relative;
    display: inline-block;
    margin: 0 auto;
    z-index: 101;
    background: #fff;
    box-shadow:0px 13px 24px 0px rgba(3,5,14,0.1);
    vertical-align: middle;
    text-align: left;
  }

  .close {
    position: absolute;
    cursor: pointer;
    top: 10px;
    right: 10px;
    font-size: 18px;
    // padding: 5px;
    z-index: 9999;
    color: #ccc;
    line-height: 1;
    width: 12px;
    height: 12px;
    background: url(~@/assets/images/modal-close.png) no-repeat left
      center;
    &:hover {
      background-position-x: center;
    }
    &:active {
      background-position-x: right;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

@keyframes h-modal-enter {
  from {
    transform: scale(0);
  }
}

@keyframes h-modal-leave {
  to {
    transform: scale(0);
  }
}

.h-modal-enter-active {
  animation: h-modal-enter 0.3s both;
}

.h-modal-leave-active {
  animation: h-modal-leave 0.5s both;
}
</style>
